import { VALIDATION_STATES } from '../../../core/const/fields.js';

export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    value: {
      type: String,
    },
    onChange: {
      type: Function,
      required: true,
    },
    onInstantChange: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isFocused: false,
      internalValue: this.value,
      visible: false,
    };
  },
  computed: {
    hasContent() {
      if (this.internalValue) {
        return this.internalValue.length > 0;
      }
      return false;
    },
    labelMessage() {
      if (this.isError) {
        return this.errorMessage;
      }
      return this.label;
    },
    isActive() {
      return this.isFocused || this.hasContent;
    },
    isValid() {
      return this.validationState === VALIDATION_STATES.valid;
    },
    isError() {
      return this.validationState === VALIDATION_STATES.error;
    },
  },
  methods: {
    toggleVisibility() {
      this.visible = !this.visible;
    },
  },
  update() {
    this.internalValue = this.value;
  },
};
